import { memo } from 'react';

export const GtinCell = memo(function GtinCell({ value }: { value: string | null }) {
  if (!value) return <span style={{ color: 'var(--ink-4)' }}>—</span>;
  return (
    <span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-xs)', color: 'var(--ink-2)' }}>
      {value}
    </span>
  );
});
